import { InitViewModel } from "./InitViewModel";

export class DashboardViewModel extends InitViewModel {
  public reload = false;
  // Texts
  public title: string = "";
}
